import { render, staticRenderFns } from "./MessageTemplatesList.vue?vue&type=template&id=9585db28&scoped=true"
import script from "./MessageTemplatesList.vue?vue&type=script&lang=js"
export * from "./MessageTemplatesList.vue?vue&type=script&lang=js"
import style0 from "./MessageTemplatesList.vue?vue&type=style&index=0&id=9585db28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9585db28",
  null
  
)

export default component.exports